import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    SAVE_ACTIVITY,
    PENDING_ACTIVITY,
    MARK_ATTENDANCE,
    ACCOUNT_LIST,
    SAVE
} from "./type";


export const saveAccount = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.parkingAccountSave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE,
            payload: data.response,
        });
        return true;
    }
};

export const accountList = (page = 1, searchKey = '', data=[{}], stage = 11) => async (dispatch) => {
    let urls = `${Config.parkingAccountList}?page=` + page+`&stage=${stage}`

    const search = window.localStorage.search_account
    if(search){
        searchKey = search
    }

    if(searchKey !== ''){
        urls = urls+"&search_key="+searchKey
    }
    Object.keys(data[0]).map((val, i)=>{
        urls+="&"+val+"="+data[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_LIST,
            payload: data.response.data,
        });
        return true;
    }
};
//
// export const accountById = (id) => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.valetAccountById}?id=${id}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: ACCOUNT_BY_ID,
//             payload: data.response,
//         });
//         return true;
//     }
// };

export const saveActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.parkingSaveActivity}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

// export const getFilter = () => async (dispatch) => {
//     const res = await callWebService(
//         callTypes.get,
//         '',
//         `${Config.valetAccountFilter}`
//     );
//     if (res) {
//         const { data } = res;
//         dispatch({
//             type: ACCOUNT_FILTER,
//             payload: data.response,
//         });
//         return true;
//     }
// };

export const getPendingActivity = (accountId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.parkingPendingActivity}?account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const markAttendance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.parkingAttendance}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MARK_ATTENDANCE,
            payload: data.response,
        });
        return data.response;
    }
};